import React from 'react'
import {
  Icon,
  Popup
} from 'semantic-ui-react'

const Tier = (props) => {
  let icon = <span></span>;
  let tooltip = <span></span>;
  switch (props.tier) {
    case 'core1':
      //icon = <Icon disabled name='battery full'/>;
      icon = <Icon disabled name='circle'/>;
      tooltip = <p><b>Core-Tier1</b>: should be a <i>required</i> part of every Computer Science curriculum.</p>;
      break;
    case 'core2':
      //icon = <Icon disabled name='battery three quarters'/>;
      icon = <Icon disabled name='pause circle'/>;
      tooltip = <p><b>Core-Tier2</b>: requiring the vast majority of Core-Tier2 topics is a minimum expectation.</p>;
      break;
    case 'elective':
      //icon = <Icon disabled name='battery empty'/>;
      icon = <Icon disabled name='circle outline'/>;
      tooltip = <p><b>Elective</b>: most programs will not cover <i>all</i> the elective material.</p>;
      break;
    default:
  }
  return (
    <Popup trigger={icon} content={tooltip}/>
  );
}

export default Tier